module.exports = __webpack_public_path__ + "static/media/b7aacd75-e06c-48e4-b31b-c35b52a592be.8ba4d01a.JPG";